export var ShippingMethodThirdPartyProvider;
(function (ShippingMethodThirdPartyProvider) {
    ShippingMethodThirdPartyProvider["MrSpeedy"] = "mr_speedy";
    ShippingMethodThirdPartyProvider["Static"] = "static";
    ShippingMethodThirdPartyProvider["GrabExpress"] = "grab_express";
    ShippingMethodThirdPartyProvider["Lalamove"] = "lalamove";
    ShippingMethodThirdPartyProvider["PandaGo"] = "pandago";
    ShippingMethodThirdPartyProvider["NinjaVan"] = "ninja_van";
    ShippingMethodThirdPartyProvider["JntExpress"] = "jnt_express";
})(ShippingMethodThirdPartyProvider || (ShippingMethodThirdPartyProvider = {}));
